module.exports = __webpack_public_path__ + "static/media/igiv-logo-small.d464013d.png";